import React, { useState } from 'react'
import { Button, Checkbox, Form, Input, Flex, Row, Col, Image, Upload } from "antd";
import { useNavigate } from "react-router-dom";
import "../../Styles/login.css";
import { UploadOutlined } from "@ant-design/icons";
import useLogin from "../../services/hooks/useLogin";


const Signup = () => {
  const [hideFields, setHideFields] = useState(false);
  const [isLoading, error, handleSignup] = useLogin("auth/signup");
  const [loginError, setLoginError] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)

  const handleRedirectLogin = () => {
    navigate('/');
  };

  const onFinish = async (values) => {
    try {
      await handleSignup(values)
    } catch (error) {
      setLoginError(error.message)
      console.log("error", error)
    } finally {
      setLoading(false)
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const beforeUpload = (file) => {
    const allowedTypes = [
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "application/pdf", // .pdf
      "text/plain", // .txt
      "image/png", // .png
      "image/jpeg", // .jpg, .jpeg
    ];

    if (!allowedTypes.includes(file.type)) {
      return Upload.LIST_IGNORE; // Ignore files not in the allowed list
    }
    return true; // Allow upload
  };

  const handleCheckbox = (e) => {
    console.log("Checkbox checked:", e.target.checked);
    setHideFields(e.target.checked);

  }

  return (
    <Row justify="center" align="middle" gutter={16} className="form_section">
      <Col md={12}>
        <div className="signup"></div>
      </Col>
      <Col md={12}>
        <Form
          className="login_form"
          name="login"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <h2>
            Sign up!</h2>
          <p>
            Explore, learn, and grow with us. enjoy a seamless and enriching educational journey. lets begin!
          </p>
          <hr className="my-4" />
          <Form.Item
            name="firstName"
            label="First name"
            rules={[{ required: true, message: "Please input your First name!" }]}
          >
            <Input className="input_field" placeholder="First name" />
          </Form.Item>
          <Form.Item
            name="lastName"
            label="Last name"
            rules={[{ required: true, message: "Please input your Last name!" }]}
          >
            <Input className="input_field" placeholder="Last name" />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, message: "Please input your Email!" }]}
          >
            <Input className="input_field" placeholder="Email" />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please input your Password!" }]}
          >
            <Input
              className="input_field"
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item
            name="role"
            label="Role"
            rules={[{ required: true, message: "Please input your Role!" }]}
          >
            <Input
              className="input_field"
              type="text"
              placeholder="Role"
            />
          </Form.Item>
          {/* <Form.Item
            name="applyInstructor"
            valuePropName="checked"
          >
            <Checkbox onClick={handleCheckbox}>Apply to become an instructor</Checkbox>
          </Form.Item>
          {hideFields && (
            <>
              <Form.Item
                name="phoneNumber"
                label="Phone Number"
                rules={[{ required: true, message: "Please input your Phone number!" }]}
              >
                <Input
                  className="input_field"
                  type="phoneNumber"
                  placeholder="Phone Number"
                />
              </Form.Item>
              <Form.Item
                name="document"
                label="Upload File"
                rules={[{ required: true, message: "Please upload a valid file!" }]}
              >
                <Upload
                  beforeUpload={beforeUpload}
                  maxCount={1}
                  listType="text"
                >
                  <Input
                    placeholder="Choose a file..."
                    addonAfter={
                      <Button icon={<UploadOutlined />} style={{ border: "none" }}>
                        Upload
                      </Button>
                    }
                    readOnly
                  />
                </Upload>
              </Form.Item>
              <Form.Item
                name="message"
                label="Message"
                rules={[{ required: true, message: "Please input your Message !" }]}
              >
                <Input.TextArea
                  className="input_field"
                  placeholder="Enter your message"
                  autoSize={{ minRows: 2, maxRows: 5 }}
                />
              </Form.Item>
            </>
          )} */}
          <Form.Item>

            <Button
              block
              type="primary"
              htmlType="submit"
              className="btn_submit"
            >
              Signup            </Button>
          </Form.Item>
          <div onClick={handleRedirectLogin} className="signup-link" > Already you have an account?
            <span style={{ cursor: "pointer", color: "#4372C2", fontWeight: '500', paddingLeft: '10px' }}> Log in</span>
          </div>
        </Form>
      </Col>
    </Row>
  )
}

export default Signup